import React from 'react'
import InstructorCourses from '../../components/instructor/Courses'
import Header from '../../components/Header'
import SideNav from '../../components/instructor/SideNav'
import CourseDetails from '../../components/instructor/CourseDetails'
function Courses() {
  return (
    <div>
    <Header/>
    <SideNav/>
    <CourseDetails/>
    </div>
  )
}

export default Courses
